import { colors, createTheme } from "@mui/material/";
import { breakpoints } from "./breakpoints";
import { palette, BLACK, BLUE_MAIN, GRAY_MAIN, WHITE, GRAY_LIGHT, BLUE_LIGHT, GREEN_LIGHT, BLUE_DARK, GREEN_LOGO, GREEN_MAIN } from "./colors";
import { spacing } from "./spacing";
import { fontWeightClasses, typography, worksans } from "./typography";
import type {} from '@mui/x-date-pickers/themeAugmentation';

export const theme = createTheme({
	typography,
	palette,
	breakpoints,
	spacing,
	shape: {
		borderRadius: 2,
	},
	components:{
		MuiInputBase: {
			styleOverrides:{
				root:{
					
				}
			}
		},
		MuiOutlinedInput:{
			styleOverrides:{
				root:{
					borderRadius:'5px'
				}
			}
		},
		MuiButton:{
			styleOverrides:{
				root: {
					borderRadius: 10,
					textTransform: "none",
					"&:hover": { backgroundColor: "darkgreen" },
					backgroundColor: GREEN_LOGO,
					border:'2px solid green',
					fontSize:'1.1em',
					padding: "5px 15px",
					"&$disabled": {
						backgroundColor: GRAY_MAIN,
						color: WHITE,
					},
				},
				sizeSmall: {
					padding: "11px 22px",
					// fontWeight: 600,
				},
				contained: {
					// backgroundColor: BLUE_MAIN,
					color: WHITE,
					"&$disabled": {
						backgroundColor: GRAY_MAIN,
						color: WHITE,
					},
				},
				containedPrimary: {
					color: WHITE,
					"&$disabled": {
						backgroundColor: GRAY_MAIN,
						color: WHITE,
					},
				},
				containedSecondary: {
					color: WHITE,
					"&$disabled": {
						backgroundColor: GRAY_MAIN,
						color: WHITE,
					},
				},
			}
		},
		MuiCheckbox:{
			styleOverrides:{
				root:{
					'&.Mui-checked': {
						color: GREEN_LOGO,
					},
				}
			}
		},
		MuiSelect:{
			styleOverrides:{
				root:{
					height:'30px',
					color: GREEN_MAIN,
					fontSize:'0.7em',
					'& .MuiSelect-select.MuiInputBase-input.MuiInput-input': {
						paddingTop: '6px',
						paddingLeft:'10px',
					},
					
					'& .MuiSelect-icon':{
						color: GREEN_MAIN
					},
					
					'& .MuiInputBase-root::before': {
						borderBottomColor: GREEN_MAIN,

					},
					'& .MuiInputBase-root::after': {
						borderBottomColor: "darkgreen",
					},
				},
			}
		},
		MuiTextField: {
			styleOverrides:{
				root:{
					'& .MuiInputLabel-root':{
						top:-4,
						fontSize:'1rem',
					},
					'& .MuiInputLabel-root.Mui-focused':{
						color: GREEN_MAIN
					},
					'& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
						borderColor: GREEN_LOGO,
					},
					'& .MuiOutlinedInput-input': {
						padding: '12px 12px',
						lineHeight: 1.4, 
						color:"grey", fontSize:'1rem',  
					},
				},
			}
		},
		MuiFormControl:{
			styleOverrides:{
				root:{
					'& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
						// borderColor: GREEN_LOGO,
						color:GREEN_MAIN
					},
					'& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
						borderColor: GREEN_LOGO,
						color:GREEN_MAIN
					},
					'& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
						borderColor: GREEN_LOGO,
						color:GREEN_MAIN
					},
					'& .MuiInputLabel-root':{
						top:11,
						// color:GREEN_MAIN,
					},
					'& .MuiInputLabel-root.Mui-focused': {
						color: GREEN_MAIN,
						// top:8 
					},
				}
			}
		},
		MuiAutocomplete:{
			styleOverrides:{
				root:{
					'& .MuiOutlinedInput-root': {
						padding:'5px 9px'
					},
					'& .MuiInputLabel-root': {
						top: -4,
						
					},
				},
				popper: {
					'& .MuiAutocomplete-option':{
						fontSize:'0.8em',
						color:"grey"
					},
					'& .MuiAutocomplete-option:hover': {
					  	backgroundColor: `${GREEN_MAIN}20 !important`
					},
				},
			}
		},
		MuiPickersToolbar:{
			styleOverrides:{
				root:{
					'& .MuiTypography-root':{
						color: BLACK+" !important",
						// '& .MuiPaper-root.MuiDialog-paper':{
						// 	color: BLACK+" !important"
						// }
					}
				}
			}
		},
		MuiDateCalendar: {
			styleOverrides: {
			  root: {
				// override generico
					color: "grey", // oppure theme.palette.grey.main se vuoi usarlo dinamico
					'& .MuiPickersMonth-monthButton.Mui-selected':{
						backgroundColor: GREEN_LOGO+" !important"
					},
					'& .MuiPickersYear-yearButton.Mui-selected':{
						backgroundColor: GREEN_LOGO+" !important"
					},
					'& .MuiPickersDay-root.Mui-selected':{
						backgroundColor: GREEN_LOGO+" !important"
					},
					'& .MuiPickersDay-root:not(.Mui-selected)': {
						// backgroundColor: GREEN_LOGO+" !important"
					}
				},
			},
		},
		MuiDialogActions:{
			styleOverrides:{
				root:{
					'& .MuiButtonBase-root.MuiButton-root':{
						color: WHITE
					}
				}
			}
		}
	},
});
